import React, { Component } from 'react';
import styled, { css } from 'styled-components';
import tagObjectArray from './SwitchTags';

import { currentLanguage, capitalize } from 'helpers';
import WP from 'WP';

import Media from 'css/Media';

class Filters extends Component {

    constructor(props) {
        super(props);
        this.state = {
            tags: [],
            active: null,
        };
    }

    componentDidMount() {
        this.handleTags();
    }

    handleTags() {
        let caseArr = [];
        let tagArr = [];

        this.props.data.map(item => {
            
            item.acf.tags.map(tag => {
                if(!caseArr.includes(tag) && tagObjectArray.filter(item => item.value === tag).length > 0) {
                    tagArr.push(tagObjectArray.filter(item => item.value === tag)[0]);
                    caseArr.push(tag);
                }
                return null;
            })
            return null;
        })
        
        let flatArr = tagArr.flat();
        
        if(this.props.season === 'northern_lights') {
            this.setState({tags: flatArr.filter(item => item.value !== 'northern_lights')})
        } else {
            this.setState({tags: flatArr});
        }
    }

    handleClick = (tag, i) => {
        this.setState({active: i});
        this.props.handleFilter(tag);
    }

    render() {
        const { tags, active } = this.state;

        return (
            <Wrapper isLong={this.props.isLong}>
                { tags.length && tags.map((item, i) =>
                    <StyledLi key={i} isActive={active === i} onClick={() => this.handleClick(item.value, i)}>
                        {currentLanguage() === 'no' ? item.title.no : item.title.en}
                    </StyledLi>
                )}
                <StyledLi isActive={active === null} onClick={() => this.handleClick('all', null)}>
                        {capitalize(WP.trans.all)}
                    </StyledLi>
            </Wrapper>
        )
    }
    
}

export default Filters;

const Wrapper = styled.ul`
    ${Media.greaterThan('s')`
        display: flex;
        justify-content: flex-end;
        align-self: center;

        ${props => props.isLong && css`
            justify-content: flex-start;
            padding-top: ${props => props.theme.spacing.elementS};
        `}
    `}
`

const StyledLi = styled.li`
    ${props => props.theme.p}
    color: ${props => props.isActive ? props.theme.colors.text : props.theme.colors.link};
    list-style-type: none;
    cursor: pointer;
    margin-right: ${props => props.theme.spacing.contentXL};

    &:last-of-type {
        margin-right: 0;
    }
`